<a [href]="externalLink" target="_blank" class="link-list-item size-{{ size }}" *ngIf="externalLink">
  <ng-container *ngTemplateOutlet="listitemcontent"></ng-container>
</a>
<a [routerLink]="link" [queryParams]="query" [fragment]="fragment" class="link-list-item size-{{ size }}" *ngIf="link">
  <ng-container *ngTemplateOutlet="listitemcontent"></ng-container>
</a>

<div class="link-list-item size-{{ size }}" *ngIf="!link && !externalLink">
  <ng-container *ngTemplateOutlet="listitemcontent"></ng-container>
</div>

<ng-template #listitemcontent>
  <div class="item-image style-{{ imageStyle }}" *ngIf="image">
    <img [src]="image | storyblokCdn" alt="" *ngIf="image !== 'EMPTY'" loading="lazy" />
  </div>
  <div class="list-item-content">
    <h3 *ngIf="title">{{ title }}</h3>
    <p *ngIf="description">{{ description }}</p>
  </div>
  <div class="link-icon" [class.external]="!!externalLink" *ngIf="link || externalLink">
    <app-svg src="/assets/icons/arrow-right.svg"></app-svg>
  </div>
  <ng-content></ng-content>
</ng-template>
